import { render } from "./DatePicker.vue?vue&type=template&id=53d9cbf9&scoped=true&ts=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=53d9cbf9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d9cbf9"]])

export default __exports__